<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Insurance Information
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Please update your informaation for the insurance purpose
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div class="row py-4">
			<div class="col-xl-12">
				<div v-if="member.is_otp_confirm==1" class="block block-rounded shadow">
					<div class="block-header border-bottom bg-primary-lighter">
						<p class="m-0 h4">
							<span v-if="member.is_verified" class="badge" :class="{'bg-success':member.is_insurance_active==1,'bg-danger':member.is_insurance_active==0}">INSURANCE <span v-if="member.is_insurance_active">ACTIVE</span><span v-else>IN-ACTIVE</span></span>
							<span v-else class="badge bg-info">FOR VERIFICATION</span>
						</p>
					</div>
					<div class="block-content block-content-full">
						<div v-if="member.is_verified==0">
							<div v-if="member.is_docu_rejected==0">
								<h4 class="text-center">Please wait 2-3 days for verification of your information</h4>
								<div class="text-center mt-5">
		  							<p>Want to change your uploaded document?</p>
		  							<inertia-link href="upload-document?change=yes" class="btn btn-success"><i class="fa fa-edit me-1"></i>Change</inertia-link>
		  						</div>
							</div>
							<div v-else>
								<div class="text-center mt-5">
		  							<h4 class="text-center">Your document was rejected, please re-upload your id again.</h4>
		  							<div><span class="text-danger"><strong>Notes:</strong></span> 
		  								<p v-html="member.docu_remarks"></p>
		  							</div>
		  							<inertia-link href="upload-document" class="btn btn-success"><i class="fa fa-upload me-1"></i>Re-upload ID</inertia-link>
		  						</div>
							</div>
						</div>
						<div v-else>
							<div class="form-floating mb-4">
								<p class="text-center fw-bold h4">Your life insurance is active until {{member.expiry_format}}</p>
								<p class="fw-bold m-0">List of Beneficiary</p>
								<p class="m-0 text-danger"><sub>Maximum of 4 beneficiary</sub></p>
								<div class="text-end"><button v-if="member.is_insurance_active==1 && beneficiaries.length<4" @click="addBeneficiary()" :disabled="action!=''" class="btn btn-outline-info btn-sm"><i class="fa fa-plus me-1"></i>Add Beneficiary</button></div>
								<table class="table">
									<thead>
										<tr>
											<th>First Name</th>
											<th>Middle Name</th>
											<th>Last Name</th>
											<th>Relation</th>
											<th>Birth Date</th>
											<th class="text-end">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(ben,index) in beneficiaries">
											<td>
												<span v-if="formBeneficiary.selected_index==index && action=='edit'">
													<input type="text" v-model="formBeneficiary.fname" name="fname" class="form-control" placeholder="First Name"/>
												</span>
												<span v-else>
													{{ben.fname}}
												</span>
											</td>
											<td>
												<span v-if="formBeneficiary.selected_index==index && action=='edit'">
													<input type="text" v-model="formBeneficiary.mname" name="mname" class="form-control" placeholder="Middle Name"/>
												</span>
												<span v-else>
													{{ben.mname}}
												</span>
											</td>
											<td>
												<span v-if="formBeneficiary.selected_index==index && action=='edit'">
													<input type="text" v-model="formBeneficiary.lname" name="lname" class="form-control" placeholder="Last Name"/>
												</span>
												<span v-else>
													{{ben.lname}}
												</span>
											</td>
											<td>
												<span v-if="formBeneficiary.selected_index==index && action=='edit'">
													<input type="text" v-model="formBeneficiary.relationship" name="relationship" class="form-control" placeholder="Relationship"/>
												</span>
												<span v-else>
													{{ben.relationship}}
												</span>
											</td>
											<td>
												<span v-if="formBeneficiary.selected_index==index && action=='edit'">
													<flat-pickr
														id="birthday"
														v-model="formBeneficiary.birthday"
														:class="
															form.errors.birthday
																? 'flatpickr-input is-invalid border-danger'
																: 'flatpickr-input'
														"
														class="form-control"
														placeholder="Enter your bday"
													/>
												</span>
												<span v-else>
													{{ben.birthday}}
												</span>
											</td>
											<td class="text-end" nowrap="">
												<span v-if="member.is_insurance_active==1">
													<span v-if="action=='edit' && formBeneficiary.selected_index==index">
														<button type="button" @click="updateBeneficiary()" class="btn btn-sm btn-outline-success me-1" title="Save Beneficiary">
															<div
																v-if="formBeneficiary.processing"
																class="spinner-border spinner-border-sm text-white me-1"
																role="status"
															>
																<span class="sr-only">Loading...</span>
															</div>
															<i class="fa fa-save"></i>
														</button>
														<button type="button" @click="cancelAddEdit()" class="btn btn-sm btn-outline-danger" title="Cancel Beneficiary"><i class="fa fa-times"></i></button>
													</span>
													<span v-if="action==''">
														<button type="button" @click="editBeneficiary(index)" class="btn btn-sm btn-outline-info me-1" title="Edit Beneficiary"><i class="fa fa-edit"></i></button>
														<button type="button" @click="deleteModal(index)" class="btn btn-sm btn-outline-danger" title="Delete Beneficiary"><i class="fa fa-trash"></i></button>
													</span>
												</span>
												<span v-if="member.is_insurance_active==0 || action=='add' || action=='delete' || (action=='edit' && formBeneficiary.selected_index!=index)">
													<button type="button" class="btn btn-sm btn-outline-info me-1 disabled" title="Disabled Edit Beneficiary"><i class="fa fa-edit"></i></button>
													<button type="button" class="btn btn-sm btn-outline-danger disabled" title="Disabled Delete Beneficiary"><i class="fa fa-trash"></i></button>
												</span>
											</td>
										</tr>
										<tr v-if="beneficiaries.length<=0 && action==''">
											<td colspan="6" class="text-center fw-bold h5 text-danger">No Beneficiaries</td>
										</tr>
										<tr v-if="action=='add'">
											<td>
												<input type="text" v-model="formBeneficiary.fname" name="fname" class="form-control" placeholder="First Name">
												<div v-if="formBeneficiary.errors.fname" class="text-danger">{{formBeneficiary.errors.fname}}</div>
											</td>
											<td>
												<input type="text" v-model="formBeneficiary.mname" name="mname" class="form-control" placeholder="Middle Name">
												<div v-if="formBeneficiary.errors.mname" class="text-danger">{{formBeneficiary.errors.mname}}</div>
											</td>
											<td>
												<input type="text" v-model="formBeneficiary.lname" name="lname" class="form-control" placeholder="Last Name">
												<div v-if="formBeneficiary.errors.lname" class="text-danger">{{formBeneficiary.errors.lname}}</div>
											</td>
											<td>
												<input type="text" v-model="formBeneficiary.relationship" name="relationship" class="form-control" placeholder="Relationship">
												<div v-if="formBeneficiary.errors.relationship" class="text-danger">{{formBeneficiary.errors.relationship}}</div>
											</td>
											<td>
												<flat-pickr
													id="birthday"
													v-model="formBeneficiary.birthday"
													:class="
														form.errors.birthday
															? 'flatpickr-input is-invalid border-danger'
															: 'flatpickr-input'
													"
													class="form-control"
													placeholder="Enter your birth day"
												/>
												<div v-if="formBeneficiary.errors.birthday" class="text-danger">{{formBeneficiary.errors.birthday}}</div>
											</td>
											<td class="text-end" nowrap="">
												<button type="button" @click="saveBeneficiary()" class="btn btn-sm btn-outline-success me-1" title="Save Beneficiary">
													<div
														v-if="formBeneficiary.processing"
														class="spinner-border spinner-border-sm text-white me-1"
														role="status"
													>
														<span class="sr-only">Loading...</span>
													</div>
													<i class="fa fa-save"></i>
												</button>
												<button type="button" @click="cancelAddEdit()" class="btn btn-sm btn-outline-danger" title="Cancel Beneficiary"><i class="fa fa-times"></i></button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<modal ref="modalDeleteBeneficiary">
		<template #title>BENEFICIARY - DELETE CONFIRMATION</template>
		<template #body>
			<p class="fw-bold">Name: {{formBeneficiary.fname}} {{formBeneficiary.lname}}</p>
			<p>Are you sure, want to delete this beneficiary?</p>
		</template>
		<template #footer>
			<button type="button" @click="confirmDeleteBeneficiary()" class="btn btn-sm btn-outline-success">
				<div
					v-if="formBeneficiary.processing"
					class="spinner-border spinner-border-sm text-white me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				<i v-else class="fa fa-check me-1"></i>
				YES
			</button>
			<button type="button" @click="closeModal()" class="btn btn-sm btn-outline-danger"><i class="fa fa-times me-1"></i>NO</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	props:{
		flash 				: Object,
		errors 				: Object,
		member 				: Object,
		beneficiaries 		: Object,
		api_response		: Object
	},
	layout: AuthLayout,
	setup(props) {

		const toast 		= createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
		})

		const action = ref('');
		const modalDeleteBeneficiary = ref(null);
		
		const form = useForm({
						id_type 			: '',
						id_type_document 	: '',
					});


		const formBeneficiary = useForm({
			id 		: 0,
			selected_index 	: null,
			prev_log_data 	: null,
			fname 			: '',
			mname 			: '',
			lname 			: '',
			relationship 	: '',
			birthday 		: ''
		})

		const img_preview = ref(null);

		const uploadFile = (e) => {

			if (e.target.files.length > 0) {
				form.id_type_document 	= e.target.files[0]
				const preview 			= URL.createObjectURL(e.target.files[0]);
				img_preview.value 		= preview;
			} else {
				form.id_type_document 	= ''
				img_preview.value 		= null;
			}
		}


		const uploadDocument = ()=>{
			form.post("upload-document/"+props.member.member_uuid,{
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member'],
				onSuccess:()=>{
					form.reset();
				},
				onError: (errors)=>{

				var fields = ['id_type','id_type_document'];
				//Check if error exist and focus the first field.
				for (var i = 0; i < fields.length; i++) {

					var found = false;

					for (const [key, value] of Object.entries(form)) {

						if(fields[i]==key){

							if(form.errors[key]){
								var  el = document.getElementById(key);

								el.focus();	

								found = true;

								break;
							}
						}
					}

					if(found==true){
						break;
					}
				}
			}
			})
		}

		const closeModal = ()=>{
			cancelAddEdit();
			modalDeleteBeneficiary.value.toggleModal();
		}

		const addBeneficiary = ()=>{
			action.value = "add";
		}

		const cancelAddEdit = ()=>{
			action.value 					= "";

			formBeneficiary.id 		= 0;
			formBeneficiary.selected_index 	= null;
			formBeneficiary.prev_log_data 	= null;
			formBeneficiary.fname 			= "";
			formBeneficiary.mname 			= "";
			formBeneficiary.lname 			= "";
			formBeneficiary.relationship 	= "";
			formBeneficiary.birthday 		= "";
		}

		const editBeneficiary = (_index)=>{
			action.value = "edit";

			formBeneficiary.id 		= props.beneficiaries[_index].id;
			formBeneficiary.selected_index 	= _index;
			formBeneficiary.fname 			= props.beneficiaries[_index].fname;
			formBeneficiary.mname 			= props.beneficiaries[_index].mname;
			formBeneficiary.lname 			= props.beneficiaries[_index].lname;
			formBeneficiary.relationship 	= props.beneficiaries[_index].relationship;
			formBeneficiary.birthday 		= props.beneficiaries[_index].birthday;

			formBeneficiary.prev_log_data  = props.beneficiaries[_index];
		}

		const deleteModal = (_index)=>{

			action.value = "delete";

			formBeneficiary.id 				= props.beneficiaries[_index].id;
			formBeneficiary.selected_index 	= _index;
			formBeneficiary.fname 			= props.beneficiaries[_index].fname;
			formBeneficiary.mname 			= props.beneficiaries[_index].mname;
			formBeneficiary.lname 			= props.beneficiaries[_index].lname;
			formBeneficiary.relationship 	= props.beneficiaries[_index].relationship;
			formBeneficiary.birthday 		= props.beneficiaries[_index].birthday;

			formBeneficiary.prev_log_data  = props.beneficiaries[_index];

			modalDeleteBeneficiary.value.toggleModal();
		}

		const saveBeneficiary = ()=>{

			formBeneficiary.post(route("member.post.add-beneficiary"),{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','beneficiaries'],
				onSuccess:()=>{
					formBeneficiary.reset();
					cancelAddEdit();

					if(props.flash)
					{
						if(props.flash.result=="success")
						{
							toast.show("Successfully added", { type: "success"});
						}else
						{
							toast.show("Failed to add", { type: "error"});
						}
					}
				},
				onError:()=>{

					var fields = ['fname','mname','lname','birthday','relationship'];
					//Check if error exist and focus the first field.
					for (var i = 0; i < fields.length; i++) {

						var found = false;

						for (const [key, value] of Object.entries(formBeneficiary)) {

							if(fields[i]==key){

								if(formBeneficiary.errors[key]){
									var  el = document.getElementById(key);

									found = true;

									break;
								}
							}
						}

						if(found==true){
							toast.show(formBeneficiary.errors[fields[i]], { type: "error"});
							break;
						}
					}

				}
			})

		}

		const updateBeneficiary = ()=>{

			formBeneficiary.put("/member/post/update-beneficiary/"+formBeneficiary.id,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','beneficiaries'],
				onSuccess:()=>{
					formBeneficiary.reset();
					cancelAddEdit();

					if(props.flash)
					{
						if(props.flash.result=="success")
						{
							toast.show("Successfully updated", { type: "success"});
						}else
						{
							toast.show("Failed to update", { type: "error"});
						}
					}
				},
				onError:()=>{

					var fields = ['fname','mname','lname','birthday','relationship'];
					//Check if error exist and focus the first field.
					for (var i = 0; i < fields.length; i++) {

						var found = false;

						for (const [key, value] of Object.entries(formBeneficiary)) {

							if(fields[i]==key){

								if(formBeneficiary.errors[key]){
									var  el = document.getElementById(key);

									found = true;

									break;
								}
							}
						}

						if(found==true){
							toast.show(formBeneficiary.errors[fields[i]], { type: "error"});
							break;
						}
					}

				}
			})

		}

		const confirmDeleteBeneficiary = ()=>{

			formBeneficiary.delete("/member/post/delete-beneficiary/"+formBeneficiary.id,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','beneficiaries'],
				onSuccess:()=>{
					formBeneficiary.reset();
					cancelAddEdit();

					if(props.flash)
					{
						if(props.flash.result=="success")
						{
							toast.show("Successfully deleted", { type: "success"});
							closeModal();
						}else
						{
							toast.show("Failed to delete", { type: "error"});
						}
					}
				}
			})

		}

		watch(()=>props.api_response,(response)=>{
			
			if(response!=null)
			{
				if(response.result=="success")
				{
					toast.show("Document was successfully uploaded", { type: response.result});
				}else
				{
					toast.show("Failed to upload", { type: "error"});
				}
			}
		})

		return{
			action,
			toast,
			form,
			formBeneficiary,
			img_preview,
			uploadFile,
			uploadDocument,
			modalDeleteBeneficiary,
			closeModal,
			addBeneficiary,
			cancelAddEdit,
			editBeneficiary,
			deleteModal,
			saveBeneficiary,
			updateBeneficiary,
			confirmDeleteBeneficiary,
		}

	},
}
</script>
